import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  auntheticated: false,
};

export const aunthSlice = createSlice({
  name: "aunth",
  initialState,
  reducers: {
    auntheticate: (state) => {
      state.auntheticated = !state.auntheticated;
    },
  },
});
export const { auntheticate } = aunthSlice.actions;
export default aunthSlice.reducer;
